import React from 'react'
import CarOverviewColorInput from 'app/React/Components/CarOverview/CarOverviewColorInput'
import ColorCode from 'app/React/Components/CarOverview/ColorCode'

export default function CarOverviewColor ({
  id,
  title,
  imageUrl,
  borderHex,
  value,
  updateColorValue,
  minimumValue
}) {
  if (typeof value !== 'number' || !id || !title || !borderHex) {
    return null
  }

  return (
    <div className='car-overview__color'>
      <ColorCode
        imageUrl={imageUrl}
        borderHex={borderHex}
        text={title}
      />
      <CarOverviewColorInput id={id} value={value} updateColorValue={updateColorValue} minimumValue={minimumValue} />
    </div>
  )
}
